import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">{siteInfo.name}</span>
            </div>
            <p className="text-sm leading-relaxed">{siteInfo.tagline}</p>
            <p className="text-xs mt-3 text-background-50/40">
              本网站内容仅供18岁以上成年人阅览
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/about" className="text-sm hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link></li>
              <li><Link to="/category/platform-recommend" className="text-sm hover:text-primary-400 transition-colors whitespace-nowrap">平台推荐</Link></li>
              <li><Link to="/category/safety-guide" className="text-sm hover:text-primary-400 transition-colors whitespace-nowrap">安全指南</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">免责声明</h4>
            <p className="text-xs leading-relaxed text-background-50/50">
              本站提供的信息仅供参考和教育目的。我们不对任何第三方平台的内容、安全性或合法性负责。用户应自行判断并遵守当地法律法规。访问和使用任何推荐平台前，请确认您已年满18周岁。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} {siteInfo.name}. 保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors" rel="nofollow">使用条款</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors" rel="nofollow">Cookie政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}